export const CATEGORIES = ['AI 对话','写作办公','图像设计','视频生成','音频语音','学习研究','编程开发','效率自动化'] as const;
export const PRICING = ['免费','免费增值','付费'] as const;
export const ACCESS = ['较稳定','可能波动','未验证'] as const;
export type Category = typeof CATEGORIES[number];
export type Pricing = typeof PRICING[number];
export type AccessStatus = typeof ACCESS[number];
export type ToolStatus = 'pending' | 'published' | 'rejected';

export interface AiTool {
  id: string;
  slug: string;
  name: string;
  summary: string;
  description: string;
  url: string;
  category: Category;
  tags: string[];
  pricing: Pricing;
  accessStatus: AccessStatus;
  chinese: boolean;
  loginRequired: boolean;
  featured: boolean;
  rank: number;
  status: ToolStatus;
  bestFor: string;
  capabilities: string[];
  logo: string;
  submitterEmail?: string;
  reviewNote?: string;
  createdAt?: string;
  updatedAt?: string;
}
